// extracted by mini-css-extract-plugin
module.exports = {"content":"_3eElgZDtLA","page":"-PNzVN-iuP","top":"_2ttlHq0M4b","title":"_1hvafWH-5D","button":"_3pCr7k8uBE","number":"_1qI0Gd-dyg"};